module.exports = __webpack_public_path__ + "img/progress-2.af33e625.jpg";